module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition.component.css
// module id = ./src/app/petition/petition.component.css
// module chunks = main